import { Component, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs/Rx';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { DiagService } from '../shared/services/diagservice';
import { Utils } from '../shared/Utils/utils';
import { SpinnerService } from '../shared/services/spinner.service';
import { NotificationBarService } from '../shared/sharedmodule/notificationbar.component';
import { Incident, Workload } from '../shared/model/models';

@Component({
  selector: 'app-incident-detail',
  templateUrl: './incident-detail.component.html',
  styleUrls: ['../app.component.css'],
})
export class IncidentDetailComponent implements OnInit {
  public id: string;

  public incident: Incident;

  public incidents: Incident[] = [];

  public filteredList: Incident[] = [];

  public calledForIncidents: boolean;

  public success: boolean;

  public open = false;

  public openmessages = true;

  public dtOptions: DataTables.Settings = {};

  public dtTrigger: Subject<any> = new Subject<any>();

  constructor(
    private service: DiagService,
    private route: ActivatedRoute,
    private spinService: SpinnerService,
    public sanitizer: DomSanitizer,
    private notificationBarService: NotificationBarService,
  ) {}

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 100,
      processing: true,
    };
    this.route.params.subscribe((params) => {
      this.success = true;
      this.id = this.route.snapshot.params.Id;

      if (this.id) {
        this.spinService.displayLoader(true);
        const sub = this.service.GetIncidentByIdOrTenantAsync(this.id).subscribe(
          (response) => {
            if (!response || response.length < 1) {
              this.notificationBarService.openSnackBar('The given incident doesnt exist', 'Warn');
              this.spinService.displayLoader(false);
              return;
            }

            this.incident = response[0];
            this.incident.Posts = this.incident.Posts.sort((a, b) => {
              if (a.CreatedTime > b.CreatedTime) {
                return -1;
              }

              if (a.CreatedTime < b.CreatedTime) {
                return 1;
              }

              return 0;
            });
            this.success = true;
            this.finalize(sub);
            this.spinService.displayLoader(false);
          },
          (error) => {
            this.finalize(sub);
            this.success = false;
            this.spinService.displayLoader(false);
          },
        );
      }
    });
  }

  public onToggle() {
    this.open = !this.open;

    if (!this.open) {
      return;
    }

    this.spinService.displayLoader(true);
    const sub = this.service.GetIncidentByIdOrTenantAsync().subscribe(
      (response) => {
        this.spinService.displayLoader(false);
        this.calledForIncidents = true;
        this.incidents = response;
        if (!response || response.length < 1) {
          return;
        }

        this.incidents.forEach((x) => {
          if (x.Classification) {
            x.ClassificationIcon = x.Classification.toLowerCase();
          }
        });
        this.filteredList = this.incidents.sort((a, b) => {
          if (a.LastUpdatedTime > b.LastUpdatedTime) {
            return -1;
          }

          if (a.LastUpdatedTime < b.LastUpdatedTime) {
            return 1;
          }

          return 0;
        });
        this.dtTrigger.next();
        this.finalize(sub);
      },
      (error) => {
        this.finalize(sub);
        this.success = false;
        this.spinService.displayLoader(false);
      },
    );
  }

  ngOnDestroy(): void {
    this.notificationBarService.dismiss();
    this.dtTrigger.unsubscribe();
  }

  public ToggleMessages() {
    this.openmessages = !this.openmessages;
  }

  public getWorkloadNames(Workloads: Workload[]) {
    if (!!Workloads && Workloads.length > 0) {
      const names: string[] = Workloads.map((obj) => {
        return obj.Name;
      });

      return names.join(',');
    }
  }

  private finalize(subscribtion: Subscription): void {
    if (subscribtion) {
      subscribtion.unsubscribe();
    }
  }
}
